import React, { Component } from 'react';
import Header from './districtHeader';
import NotificationSystem from 'react-notification-system';
/* import AddNewSchool from '../SchoolList/addNewSchool' */
import DashBoard from './districtDashboardNew'
import Application from '../Applications/applicationDetails'
import ApplicationSetting from '../Applications/applicationSetting'
import DistricteligibilityCodeSettings from '../districteligibilityCodeSettings'
import DistrictCertificationSettings from '../districtDirectCertificationSettings'
import ApplicationVerification from '../applicationVerification'
import DepositSummary from '../Deposits/depositSummary'
import AuditReportPage from '../auditReport/auditReport'
import LunchSummary from '../Lunchs/lunchSummary'
//import RegisterSchool from '../AddSchool/registerSchool'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Users from '../Users';
import UserRecord from '../Users/userRecord';
import FilterBar from '../../Caterer/Home/FilterBar'
/* import ManageStudents from '../manageStudents'; */
import StudentLookUpDistrict from '../manageStudents/studentLookUpDistrict'
import StudentDetails from '../manageStudents/studentDetails';
import ImportCertification from '../ImportCertification';
import Reports from '../Reports';
import ESEAFormList from './../EseaForm';
import Settings from '../Settings';
import VerificationReports from '../VerificationReport';

let data = {};
let catererdata = {};

class DistrictHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSchoolsFilter: true,
            selectSchool: 0,
            schoolList: []
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.initSchools();
    }
    initSchools = () => {
        const schools = (JSON.parse(sessionStorage.getItem('loggedInUserDetails')) || {}).schools || [];
        //const sid=schools.length>0?schools[0].schoolId:0
        this.setState({
            schoolList: schools
            //,selectedSchool:sid
        });
    }
    setSelectedSchool = (id) => {
        this.setState({ selectSchool: id })
    }
    changeShowHideSchoolFitler = (showHide) => {
        this.setState({ showSchoolsFilter: showHide });
    }
    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <Router>
                    <div style={{ overflowY: 'scroll', overflowX: 'hidden', height: '90vh' }}>
                        <Header />
                        {
                            this.state.showSchoolsFilter &&
                            <FilterBar
                                showSchoolsDropdown={true}
                                selectSchool={this.state.selectSchool}
                                schoolList={this.state.schoolList}
                                onSchoolChange={(id) => {
                                    this.setState({ selectSchool: id });

                                }}
                                showSchoolOpen={true}
                                hideMealType={true} />
                        }
                        <Switch>
                            <Route exact={true} path="/district/applicationDetails" render={() => <Application {...this} {...this.state} />} />
                            <Route exact={true} path="/district/applicationSetting" render={() => <ApplicationSetting {...this} {...this.state} />} />
                            <Route exact={true} path="/district/districtDirectCertificationSettings" render={() => <DistrictCertificationSettings {...this} {...this.state} />} />
                            <Route exact={true} path="/district/districteligibilityCodeSettings" render={() => <DistricteligibilityCodeSettings {...this} {...this.state} />} />
                            <Route exact={true} path="/district/applicationVerification" render={() => <ApplicationVerification {...this} {...this.state} />} />
                            <Route exact={true} path="/district/depositSummary" render={() => <DepositSummary {...this} {...this.state} />} />
                            {/*  <Route exact={true} path="/district/manageStudents" render={() => <ManageStudents {...this} {...this.state} />}/> */}
                            <Route exact={true} path="/district/studentLookUp" render={() => <StudentLookUpDistrict {...this} {...this.state} />} />
                            <Route exact={true} path="/district/studentInfo/:id" render={() => <StudentDetails {...this} {...this.state} />} />
                            <Route exact={true} path="/district/auditReport" render={() => <AuditReportPage {...this} {...this.state} />} />
                            <Route exact={true} path="/district/users" render={() => <Users {...this} {...this.state} />} />
                            <Route exact={true} path="/district/reports" render={() => <Reports {...this} {...this.state} />} />
                            <Route exact={true} path="/district/VerificationReport" render={() => <VerificationReports  {...this} {...this.state} />} />
                            <Route exact={true} path="/district/importCertificationData" render={() => <ImportCertification {...this} {...this.state} />} />
                            <Route exact={true} path="/district/userRecord/:id" render={() => <UserRecord {...this} {...this.state} />} />
                            <Route exact={true} path="/district/settings" render={() => <Settings {...this} {...this.state} />} />
                            <Route path="/district/eseaFormList" render={() => <ESEAFormList {...this} {...this.state} />} />
                            <Route exact={true} path="/district/lunchs" render={() => <LunchSummary {...this} {...this.state} />} />
                            <Route render={() => <DashBoard {...this} {...this.state} />} />
                        </Switch>
                    </div>
                </Router>
            </div>)
    }
}
export default DistrictHome;


// WEBPACK FOOTER //
// ./src/components/District/Home/districtHome.jsx